import { render, staticRenderFns } from "./Voucher-Search.vue?vue&type=template&id=0567ba4e&scoped=true&"
import script from "./Voucher-Search.vue?vue&type=script&lang=js&"
export * from "./Voucher-Search.vue?vue&type=script&lang=js&"
import style0 from "./Voucher-Search.vue?vue&type=style&index=0&id=0567ba4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0567ba4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0567ba4e')) {
      api.createRecord('0567ba4e', component.options)
    } else {
      api.reload('0567ba4e', component.options)
    }
    module.hot.accept("./Voucher-Search.vue?vue&type=template&id=0567ba4e&scoped=true&", function () {
      api.rerender('0567ba4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Gr4SuFErSqSY/JS/comp/Voucher-Search.vue"
export default component.exports